export const ANALYTICS_EVENTS = {
  PAGE_VIEW: "page_view",
  PRODUCT_VIEW: "product_view",
  PRODUCT_ACTION: "product_action",
};

export const PRODUCT_ANALYTICS = {
  PRODUCT_NAME: "RouteMotion",
  PAGE_PRODUCTS: "products_page",
  PAGE_PRODUCT_DETAILS: "product_details_page",
  ACTION_REQUEST_TO_BUY: "Request To Buy",
  ACTION_GET_SUPPORT: "Get Support",
  ACTION_PRE_SALES_QUESTION: "Pre-Sales Question",
  ACTION_REQUEST_FOR_CUSTOMIZATION: "Request For Customization",
  ACTION_DOWNLOAD_APK: "Download APK",
};
